export default __webpack_public_path__ + "static/char-58-7d607b5a7b50c5a104b95b3285fe7453.webp";